import type { SxProps, Theme } from '@mui/material';

export const REPLANNING_ALERT_SX: SxProps<Theme> = {
    mx: 1.5,
    mt: 1.5,
    py: 0.5,
    fontSize: 11.5,
    alignItems: 'center',
    '& .MuiAlert-icon': { py: 0, mr: 1 },
    '& .MuiAlert-message': { py: 0 },
};
